const getInitials = (displayName, initialsCount = 2) =>
  displayName
    .split(' ')
    .filter((_, i) => i < initialsCount)
    .map(n => n[0])
    .join('')
    .toUpperCase();

export default getInitials;
